const primary = '#25bdbe'

export const Styles = () => (
  // eslint-disable-next-line react/no-unknown-property
  <style global jsx>{`
    .MuiTab-root {
      text-transform: none !important;
      min-width: 72;
      font-weight: normal;
      margin-right: 10px;
    }
    .MuiTab-root:hover {
      color: ${primary};
      opacity: 1;
    }
    .MuiTab-root[aria-selected='true'] {
      color: ${primary} !important;
      font-weight: bold;
    }
    .MuiTab-root:focus {
      color: ${primary};
    }

    .MuiTab-root {
      margin-right: 0px;
    }
    .MuiTab-root:hover {
      background: #dbfbf7;
    }
    .MuiTab-root:hover span {
      color: #25bdbe;
    }
    .MuiTabScrollButton-root {
      transition: 200ms;
    }
    .MuiTabScrollButton-root.Mui-disabled {
      opacity: 0;
      width: 0;
    }
    .signatures-component .block-name {
      font-size: 16px;
      padding: 8px 14px;
      display: flex;
      align-items: center;
      border-radius: 4px;
      margin-bottom: 7px;
      border: 2px #d6d6d6 solid;
      background: transparent;
      color: #101212;
      font-weight: bold;
    }
    .signatures-component .block-name svg {
      margin-right: 10px;
    }
    .signatures-component
      .signature-block
      .signatures-in-block
      .signature-component {
      padding-bottom: 10px;
      padding-top: 4px;
      margin-bottom: 10px;
      margin-left: 46px;
    }
    .signatures-component
      .signature-block
      .signatures-in-block
      .signature-component
      b {
      margin-right: 10px;
    }
    .signatures-component
      .signature-block
      .signatures-in-block
      .signature-component:not(:last-child) {
      border-bottom: 1px #d2d2d2 solid;
    }
    .MuiTabs-scroller {
      margin-bottom: 0px;
      margin-left: 0px;
    }
    @media only screen and (min-width: 760px) {
      .MuiTabs-scroller {
        margin-left: 30px;
      }
    }
    .primary-tabs {
      border-bottom: 1px #dedede solid;
    }
    .primary-tabs .MuiTabs-indicator {
      height: 3px;
      background-color: ${primary};
    }
    .primary-tabs button {
      opacity: 1;
      min-height: 60px;
    }
    .primary-tabs button span {
      color: #101212;
      font-size: 16px;
      letter-spacing: 0;
      white-space: nowrap;
    }
    .primary-tabs button.Mui-selected {
      background: #dbfbf7;
    }
    .primary-tabs button.Mui-selected span {
      color: #25bdbe;
      font-weight: bold;
    }
    .secondary-tabs .MuiTabs-indicator {
      height: 0px;
    }
    .secondary-tabs button span {
      font-size: 15px;
    }
    .secondary-tabs button.Mui-selected span {
      font-weight: bold;
    }
    .content {
      background-color: #f4f7f9;
      min-height: 350px;
      padding: 21px;
    }
    .content .download-button button {
      padding: 10px 20px;
      margin: 0 -20px;
    }
    .content .download-button button:hover {
      text-decoration: underline;
      background: #dbfbf7;
    }
    .content .download-button svg {
      max-height: 22px;
      margin-right: 6px;
      min-width: 20px;
    }
    .content .download-button button {
      font-weight: bold;
      color: ${primary};
      display: flex;
    }

    .content .download-button svg path {
      fill: ${primary};
    }
    @media only screen and (max-width: 760px) {
      .content {
        padding: 20px 10px;
      }
    }
    .content > ul {
      padding: 0px;
    }
    .content .MuiTreeItem-root {
      /* padding: 0 20px;
    */
    }
    .content .MuiTreeItem-root .MuiTreeItem-content .MuiTreeItem-iconContainer {
      margin-left: 20px;
    }
    .content .MuiTreeItem-root .MuiTreeItem-content .MuiTreeItem-label {
      word-wrap: break-word;
      max-width: calc(100% - 55px);
    }
    .content .MuiTreeItem-root .MuiTreeItem-label {
      background-color: transparent !important;
    }
    .content .MuiTreeItem-root svg {
      width: 30px;
      height: 30px;
      max-width: 30px;
      color: #25bdbe;
    }
    .content .MuiTreeItem-root[aria-expanded] > .MuiTreeItem-content:hover {
      cursor: pointer;
      background: #dbfbf7;
    }

    .content .MuiTreeItem-root > .MuiTreeItem-content {
      padding-left: 20px;
      padding-right: 20px;
    }
    .content .MuiTreeItem-root > .MuiTreeItem-content:hover {
      cursor: auto;
      background: #eee;
    }
    .content .MuiTreeItem-root > .MuiTreeItem-content.Mui-expanded {
      border-bottom: 2px #25bdbe solid;
      background: #dbfbf7;
    }
    .content .MuiTreeItem-root > .MuiTreeItem-content.Mui-expanded b {
      color: #25bdbe !important;
    }
    .content .MuiTreeItem-root.Mui-selected b {
      color: #25bdbe;
    }
    .content .MuiTreeItem-root .MuiTreeItem-content {
      padding: 6px 0;
    }
    .content .MuiTreeItem-root .MuiTreeItem-content.Mui-selected {
      background-color: rgb(219 251 247 / 50%);
    }
    .content .MuiTreeItem-root .MuiTreeItem-label > div > span,
    .content .MuiTreeItem-root .MuiTreeItem-label > div > b {
      font-size: 16px;
      margin-right: 10px;
      color: #101212 !important;
    }
  `}</style>
)
